import { RadioInterface } from '../interfaces/radio.interface';

export class RadioModel {
  label: string;
  text: string;
  checked?: boolean;

  constructor( obj: RadioInterface ) {

    this.label = obj && obj.label ? obj.label : '';
    this.text = obj && obj.text ? obj.text : '';
    this.checked = obj && obj.checked !== undefined ? obj.checked : false;

  }

}
